import React, { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { faChevronDown, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClassroomList } from '../../Context/ClassroomListContext';
import clientAxios from '../../clients/clientAxios';
import '../../styles/debtCollections.css';
import PaymentHistorial from '../students/details/modals/PaymentHistorial';
import StudentCommissions from '../students/details/modals/StudentCommissions';

const DebtCollection = () => {
  const classroomList = useContext(ClassroomList);
  const [debtorsList, setDebtorsList] = useState(null);
  const [sortedClassroomList, setSortedClassroomList] = useState(null);
  const [debtorsByClassroom, setDebtorsByClassroom] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState('');
  const [isClassroomDropdownOpen, setIsClassroomDropdownOpen] = useState(false);
  const [showPaymentHistorialModal, setShowPaymentHistorialModal] =
    useState(false);
  const [idStudent, setIdStudent] = useState('');
  const [statusCommisionChangeFlag, setStatusCommisionChangeFlag] =
    useState(false);
  const currencyFormatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  const getDebtorsList = async () => {
    try {
      setIsLoading(true);
      const { data } = await clientAxios(
        `/bills/debtors-interest-rate?classroom=${selectedClassroom}`
      );
      setDebtorsList(data);
      setDebtorsByClassroom(data.details);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClassroomInputChange = (changeEvent) => {
    setSelectedClassroom(changeEvent.target.value);
    setIsClassroomDropdownOpen(true);
  };

  const handleClassroomFocus = () => {
    setIsClassroomDropdownOpen(true);
  };

  const handleClassroomToggle = () => {
    setIsClassroomDropdownOpen((previousOpen) => !previousOpen);
  };

  const handleClassroomClear = () => {
    setSelectedClassroom('');
    setIsClassroomDropdownOpen(true);
  };

  const handleClassroomSelect = (classroomName) => {
    setSelectedClassroom(classroomName);
    setIsClassroomDropdownOpen(false);
  };

  const classroomOptions =
    sortedClassroomList || classroomList?.crList || [];
  const normalizedClassroomQuery = selectedClassroom.trim().toLowerCase();
  const filteredClassrooms = normalizedClassroomQuery
    ? classroomOptions.filter((classroomItem) =>
      (classroomItem.classroom || '')
        .toLowerCase()
        .includes(normalizedClassroomQuery)
    )
    : classroomOptions;

  const handleSearch = () => {
    getDebtorsList();
  };

  useEffect(() => {
    if (classroomList?.crList?.length) {
      const sortedClassrooms = [...classroomList.crList].sort((first, second) => {
        const dateA = new Date(first.createdAt);
        const dateB = new Date(second.createdAt);
        return dateB - dateA;
      });
      setSortedClassroomList(sortedClassrooms);
    }
  }, [classroomList]);

  const openModalPaymentHistory = (id) => {
    setIdStudent(id);
    setShowPaymentHistorialModal(!showPaymentHistorialModal);
  };

  return (
    <Container>
      <PaymentHistorial
        show={showPaymentHistorialModal}
        onHide={() => setShowPaymentHistorialModal(!showPaymentHistorialModal)}
        studentId={idStudent}
      />
      <Row>
        <Col className='bg-light rounded shadow d-flex justify-content-center py-3 mb-3'>
          <Col md='6'>
            <Form.Group>
              <Form.Label>Comisión:</Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  onChange={handleClassroomInputChange}
                  onFocus={handleClassroomFocus}
                  onClick={handleClassroomFocus}
                  onBlur={() =>
                    setTimeout(() => setIsClassroomDropdownOpen(false), 150)
                  }
                  value={selectedClassroom}
                  name='classroom'
                  autoComplete='off'
                  style={{ paddingRight: '60px' }}
                  placeholder={
                    classroomList?.crList.length === 0
                      ? 'Cargando lista...'
                      : 'Ver Todas / Buscar comisión...'
                  }
                />
                <div
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    gap: '4px',
                  }}
                >
                  {selectedClassroom && (
                    <Button
                      variant='link'
                      size='sm'
                      className='p-0 text-muted'
                      onMouseDown={(mouseEvent) =>
                        mouseEvent.preventDefault()
                      }
                      onClick={handleClassroomClear}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Button>
                  )}
                  <Button
                    variant='link'
                    size='sm'
                    className='p-0 text-muted'
                    onMouseDown={(mouseEvent) => mouseEvent.preventDefault()}
                    onClick={handleClassroomToggle}
                  >
                    <FontAwesomeIcon icon={faChevronDown} />
                  </Button>
                </div>
                {isClassroomDropdownOpen && (
                  <div
                    className='list-group'
                    style={{
                      position: 'absolute',
                      zIndex: 1000,
                      width: '100%',
                      maxHeight: '220px',
                      overflowY: 'auto',
                    }}
                  >
                    <button
                      type='button'
                      className='list-group-item list-group-item-action'
                      onMouseDown={(mouseEvent) => mouseEvent.preventDefault()}
                      onClick={() => handleClassroomSelect('')}
                    >
                      Ver Todas
                    </button>
                    {filteredClassrooms.map((classroom) => (
                      <button
                        type='button'
                        key={classroom._id || classroom.classroom}
                        className='list-group-item list-group-item-action'
                        onMouseDown={(mouseEvent) =>
                          mouseEvent.preventDefault()
                        }
                        onClick={() =>
                          handleClassroomSelect(classroom.classroom)
                        }
                      >
                        {classroom.classroom}
                      </button>
                    ))}
                    {filteredClassrooms.length === 0 && (
                      <span className='list-group-item text-muted'>
                        Sin resultados
                      </span>
                    )}
                  </div>
                )}
              </div>
            </Form.Group>
          </Col>
          <Col className='my-auto'>
            <Button
              className={`w-100 mt-3 disabledCursor`}
              variant='info'
              type='submit'
              onClick={handleSearch}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faSearch} /> Filtrar
            </Button>
          </Col>
        </Col>
      </Row>
      <Row className='text-center'>
        {debtorsList && !isLoading && (
          <>
            <Col>
              <h5>{`Total: ${debtorsList?.totalDebtors}`}</h5>
            </Col>
            <Col>
              {debtorsList && !isLoading && (
                <span className='mt-2'>
                  Porcentaje de deudores:
                  {debtorsList?.debtorsPercent.toFixed(2)}%
                </span>
              )}
            </Col>
          </>
        )}
      </Row>
      <div className='bg-light rounded p-3 mb-3'>
        {isLoading ? (
          <Col className=' col-12 text-center'>
            <Spinner animation='grow' />
          </Col>
        ) : debtorsByClassroom?.length === 0 ? (
          <div className='text-center'>
            <Alert key='selectClassroom' variant='warning'>
              No hay deudores para mostrar en esta comisión
            </Alert>
          </div>
        ) : !isLoading && !debtorsByClassroom ? (
          <div className='text-center'>
            <Alert key='selectClassroom' variant='primary'>
              No hay alumnos para mostrar
            </Alert>
          </div>
        ) : (
          debtorsByClassroom && (
            <Table striped bordered hover size='sm'>
              <thead>
                <tr>
                  <th>Alumno</th>
                  <th>Cuotas</th>
                  <th>Estado de la deuda</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {debtorsByClassroom?.map((debtor, debtorIndex) => {
                  const baseDebt =
                    debtor.debtStatus.expectedPaymentToCurrentDate -
                    debtor.debtStatus.totalAmountPaidSoFar;
                  const accumulatedDebt =
                    baseDebt > 0 ? baseDebt * 1.07 : 0;
                  return (
                    <>
                      <tr key={`debtorName-${debtorIndex}`} className='mb-3'>
                        <td>
                          <span>{debtor.name}</span>{' '}
                          <span>{debtor.lastname}</span>
                          <small>
                            {debtorsList.notSuspended.some(
                              (item) => item.email === debtor.email
                            ) ? null : (
                              <p className='text-danger'>Suspendido</p>
                            )}
                          </small>
                        </td>
                        <td>
                          {debtorsByClassroom?.map((detail, detailIndex) => {
                            if (debtorIndex === detailIndex) {
                              return (
                                <span>
                                  {
                                    detail.debtStatus.installments[0]
                                      .monthlyInstallment[0]
                                  }{' '}
                                  / {detail.debtStatus.plan.priceSchema.length}
                                </span>
                              );
                            }
                          })}
                        </td>
                        <td>
                          <span>
                            Total pagado actualmente:
                            <span>
                              {currencyFormatter.format(
                                Number(
                                  debtor.debtStatus.totalAmountPaidSoFar
                                ) || 0
                              )}
                            </span>
                          </span>
                          <br />
                          <span>
                            Total esperado:
                            <span className='text-danger'>
                              {currencyFormatter.format(
                                Number(
                                  debtor.debtStatus
                                    .expectedPaymentToCurrentDate
                                ) || 0
                              )}
                            </span>
                          </span>
                          <span>
                            <br />
                            Deuda acumulada:
                            <span className='text-danger'>
                              {currencyFormatter.format(accumulatedDebt)}
                            </span>
                          </span>
                        </td>
                        <td>
                          <div className='d-flex flex-column align-items-center justify-content-center mh-100'>
                            <OverlayTrigger
                              placement='left'
                              overlay={
                                <Tooltip id='tosoltip'>
                                  <strong>Histrial de pagos</strong>
                                </Tooltip>
                              }
                            >
                              <Button
                                size='sm'
                                className='mb-2'
                                onClick={() => {
                                  openModalPaymentHistory(debtor?._id);
                                }}
                              >
                                <FontAwesomeIcon icon={faSearch} />
                              </Button>
                            </OverlayTrigger>
                            <StudentCommissions
                              studentId={debtor._id}
                              isActive={null}
                              debtorsList={debtorsList}
                              setDebtorsList={setDebtorsList}
                              setStatusCommisionChangeFlag={
                                setStatusCommisionChangeFlag
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </Table>
          )
        )}
      </div>
    </Container>
  );
};

export default DebtCollection;
